import { createFileRoute } from "@tanstack/react-router";
import ImportPage from "@/pages/Import";
import SubscribedRoute from "@/components/shared/SubscribedRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/dashboard/inventory/import/")({
  head: () => routeHead("/de/dashboard/inventory/import/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SubscribedRoute><ImportPage /></SubscribedRoute>
  );
}
